import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CasinoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"casino"}/>
}
